import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-qr-accordion',
  templateUrl: './qr-accordion.component.html',
  styleUrls: ['./qr-accordion.component.css']
})
export class QrAccordionComponent {
  @Input() title: string = '';
  @Input() isCollapsed: boolean = true;
  @Output() isCollapsedChange = new EventEmitter<boolean>();

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/ui/qr-accordion/qr-accordion.component.ts